import React, { useState, useEffect } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { Card, Table, Badge, Button, Row, Col, Spinner, Form as BSForm } from 'react-bootstrap';
import Pagination from 'react-js-pagination';
import { toast } from 'react-toastify';
import { Tooltip, Tag, Button as AntButton, Modal, Input } from 'antd';
import { CheckOutlined, CloseOutlined, FileTextOutlined, UndoOutlined, EditOutlined, DeleteOutlined } from '@ant-design/icons';
import { getInfomationAccountFromToken } from '@app/utils/helper';
import { Get, Put, Post, DeleteSingle } from '@app/utils/httpProvider';
import { SACH_API, BaseGatewayImage, ACCOUNT_API } from '@app/utils/apiUrl';
import { LOAI_SACH, VAI_TRO_SACH, trangThaiPheDuyetValue, objectTrangThaiPheDuyet } from '@app/utils/define';
import { SachModal } from '@app/pages/HoSo/HoSoModals';

const { TextArea } = Input;
import ResearchTabs from '@app/components/ResearchTabs';

const SachList = () => {
    const history = useHistory();
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const pageFromQuery = parseInt(query.get('page')) || 1;

    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [totalItems, setTotalItems] = useState(0);
    const [pageIndex, setPageIndex] = useState(pageFromQuery);
    const [pageSize] = useState(20);
    const [keyword, setKeyword] = useState('');
    const [searchLoaiSach, setSearchLoaiSach] = useState('');
    const [searchSoTacGia, setSearchSoTacGia] = useState('');
    const [searchTrangThai, setSearchTrangThai] = useState('');
    const [searchNhaXuatBan, setSearchNhaXuatBan] = useState('');
    const [searchNamXuatBan, setSearchNamXuatBan] = useState('');
    const [searchVaiTro, setSearchVaiTro] = useState('');
    const [searchTenNhanVien, setSearchTenNhanVien] = useState('');
    const [filterQuery, setFilterQuery] = useState({});
    
    // Phê duyệt
    const [rejectVisible, setRejectVisible] = useState(false);
    const [rejectReason, setRejectReason] = useState('');
    const [rejectTargetId, setRejectTargetId] = useState(null);

    const currentUser = getInfomationAccountFromToken();
    const isAdmin = currentUser?.role?.toLowerCase().includes('admin') || currentUser?.role?.toLowerCase().includes('publisher') || currentUser?.role?.toLowerCase().includes('manager');
    const isSearchVisible = currentUser?.role?.toLowerCase().includes('admin') || currentUser?.role?.toLowerCase().includes('manager');
    const isEditor = currentUser?.role?.toLowerCase().includes('editor');
    const [addModalVisible, setAddModalVisible] = useState(false);
    const [selectedItem, setSelectedItem] = useState({});
    const [nhanVienId, setNhanVienId] = useState(null);

    useEffect(() => {
        let active = true;
        if (currentUser?.id) {
            Get(ACCOUNT_API.GET_BY_ID_ACCOUNT, currentUser.id)
                .then(res => {
                    if (active && res && res.nhanVienId) {
                        setNhanVienId(res.nhanVienId);
                    }
                }).catch(e => console.error(e));
        }
        return () => {
            active = false;
        };
    }, [currentUser?.id]);

    const handleSaveItem = async (values) => {
        try {
            const payload = {
                ...values,
                nhanVienId: nhanVienId
            };
            let res;
            if (selectedItem?.id) {
                res = await Put(SACH_API.EDIT_ITEM, selectedItem.id, payload);
            } else {
                res = await Post(SACH_API.ADD_ITEM, null, payload, false);
            }
            if (res && !res.error) {
                toast.success(selectedItem?.id ? "Cập nhật thành công!" : "Khai báo thành công! Đang chờ phê duyệt.");
                setAddModalVisible(false);
                loadData();
            } else {
                toast.error(res?.message || "Không lưu được dữ liệu");
            }
        } catch (e) {
            toast.error("Không lưu được dữ liệu");
        }
    };

    const handleDeleteItem = async (id) => {
        Modal.confirm({
            title: 'Xác nhận xóa bản ghi?',
            content: 'Dữ liệu này sẽ bị xóa vĩnh viễn khỏi hệ thống.',
            okText: 'Xóa bỏ',
            okType: 'danger',
            cancelText: 'Hủy',
            onOk: async () => {
                try {
                    const res = await DeleteSingle(SACH_API.DELETE_ITEM, id);
                    if (res && !res.error) {
                        toast.success("Xóa dữ liệu thành công!");
                        loadData();
                    } else {
                        toast.error(res?.message || "Không thể xóa bản ghi!");
                    }
                } catch (e) {
                    toast.error(e.message || "Không thể xóa bản ghi!");
                }
            }
        });
    };

    const handlePageChange = (num) => {
        setPageIndex(num);
        const params = new URLSearchParams(location.search);
        params.set('page', num);
        history.push(`${location.pathname}?${params.toString()}`);
    };

    useEffect(() => {
        loadData();
    }, [pageIndex, filterQuery]);

    useEffect(() => {
        const pageFromQuery = parseInt(new URLSearchParams(location.search).get('page')) || 1;
        setPageIndex(pageFromQuery);
    }, [location.search]);

    const loadData = async () => {
        setLoading(true);
        try {
            const params = {
                PageIndex: pageIndex,
                PageSize: pageSize,
                Keyword: filterQuery.Keyword || ''
            };
            if (filterQuery.LoaiSach) params.LoaiSach = filterQuery.LoaiSach;
            if (filterQuery.SoTacGia) params.SoTacGia = filterQuery.SoTacGia;
            if (filterQuery.TrangThaiPheDuyet) params.TrangThaiPheDuyet = filterQuery.TrangThaiPheDuyet;
            if (filterQuery.NhaXuatBan) params.NhaXuatBan = filterQuery.NhaXuatBan;
            if (filterQuery.NamXuatBan) params.NamXuatBan = filterQuery.NamXuatBan;
            if (filterQuery.VaiTro) params.VaiTro = filterQuery.VaiTro;
            if (filterQuery.TenNhanVien) params.TenNhanVien = filterQuery.TenNhanVien;

            const res = await Get(SACH_API.GET_PAGING, null, params);
            if (res && res.data) {
                setData(res.data);
                setTotalItems(res.totalRecords || 0);
            }
        } catch (error) {
            console.error("Lỗi khi tải danh sách sách:", error);
            toast.error("Có lỗi xảy ra khi tải dữ liệu sách");
        }
        setLoading(false);
    };

    const handleApprove = async (id) => {
        try {
            const res = await Put(SACH_API.APPROVE, id);
            if (res) {
                toast.success("Phê duyệt thành công!");
                loadData();
            }
        } catch (e) {
            toast.error("Phê duyệt thất bại");
        }
    };

    const handleRevoke = async (id) => {
        try {
            const res = await Put(SACH_API.REVOKE, id);
            if (res) {
                toast.success("Thu hồi thành công!");
                loadData();
            }
        } catch (e) {
            toast.error("Thu hồi thất bại");
        }
    };

    const openRejectModal = (id) => {
        setRejectTargetId(id);
        setRejectReason('');
        setRejectVisible(true);
    };

    const handleRejectSubmit = async () => {
        if (!rejectReason.trim()) {
            toast.warning("Vui lòng nhập lý do từ chối");
            return;
        }
        try {
            const res = await Put(SACH_API.REJECT, rejectTargetId, { LyDoTuChoi: rejectReason });
            if (res) {
                toast.success("Đã từ chối bản ghi thành công!");
                setRejectVisible(false);
                loadData();
            }
        } catch (e) {
            toast.error("Thao tác thất bại");
        }
    };

    const getFirstFileName = (jsonString) => {
        if (!jsonString) return null;
        try {
            let files = [];
            const trimmed = typeof jsonString === 'string' ? jsonString.trim() : '';
            if (trimmed.startsWith('[') && trimmed.endsWith(']')) {
                files = JSON.parse(jsonString);
            } else {
                files = [jsonString];
            }
            if (!Array.isArray(files) || files.length === 0) return null;
            const url = files[0];
            if (!url) return null;
            return url.split('/').pop().split('\\').pop();
        } catch (e) {
            if (typeof jsonString === 'string') {
                return jsonString.split('/').pop().split('\\').pop();
            }
            return null;
        }
    };

    const renderFirstFileLink = (jsonString) => {
        const fileName = getFirstFileName(jsonString);
        if (!fileName) return null;
        
        let fullUrl = '';
        try {
            let files = [];
            const trimmed = typeof jsonString === 'string' ? jsonString.trim() : '';
            if (trimmed.startsWith('[') && trimmed.endsWith(']')) {
                files = JSON.parse(jsonString);
            } else {
                files = [jsonString];
            }
            const url = files[0];
            if (url) {
                if (url.startsWith("http://") || url.startsWith("https://")) {
                    fullUrl = url;
                } else {
                    fullUrl = BaseGatewayImage + (url.startsWith("/") ? "" : "/") + url;
                }
            }
        } catch (e) {
            const url = jsonString;
            if (typeof jsonString === 'string') {
                if (url.startsWith("http://") || url.startsWith("https://")) {
                    fullUrl = url;
                } else {
                    fullUrl = BaseGatewayImage + (url.startsWith("/") ? "" : "/") + url;
                }
            }
        }
        
        if (!fullUrl) return null;
        
        return (
            <div className="mt-1" style={{ fontSize: '12px' }}>
                <a href={fullUrl} target="_blank" rel="noopener noreferrer" className="text-success font-weight-normal">
                    Đã tải lên: {fileName}
                </a>
            </div>
        );
    };

    const renderApprovalBadge = (item) => {
        const status = item.trangThaiPheDuyet;
        if (status === trangThaiPheDuyetValue.daPheDuyet) return <Tag color="success">Đã duyệt</Tag>;
        if (status === trangThaiPheDuyetValue.choPheDuyet) return <Tag color="warning">Chờ duyệt</Tag>;
        return (
            <div className="d-flex flex-column align-items-center gap-1">
                <Tag color="error">Từ chối</Tag>
                {item.lyDoTuChoi && (
                    <div className="text-danger text-center" style={{ fontSize: '11px', whiteSpace: 'pre-wrap', maxWidth: '150px' }}>
                        Lý do: {item.lyDoTuChoi}
                    </div>
                )}
            </div>
        );
    };

    const renderActionButtons = (item) => {
        const isApproved = item.trangThaiPheDuyet === trangThaiPheDuyetValue.daPheDuyet;
        const canEdit = !isApproved && isEditor;

        return (
            <div className="d-flex flex-column align-items-center gap-1 w-100 mt-1">
                {/* Giảng viên Sửa/Xóa */}
                {canEdit && (
                    <div className="d-flex gap-2 justify-content-center mb-1">
                        <Tooltip title="Chỉnh sửa">
                            <AntButton
                                type="text"
                                icon={<EditOutlined style={{ color: '#1890ff' }} />}
                                onClick={() => {
                                    setSelectedItem(item);
                                    setAddModalVisible(true);
                                }}
                            />
                        </Tooltip>
                        <Tooltip title="Xóa">
                            <AntButton
                                type="text"
                                danger
                                icon={<DeleteOutlined />}
                                onClick={() => handleDeleteItem(item.id)}
                            />
                        </Tooltip>
                    </div>
                )}

                {/* Admin Duyệt/Từ chối khi đang chờ duyệt */}
                {isAdmin && item.trangThaiPheDuyet === trangThaiPheDuyetValue.choPheDuyet && (
                    <div className="d-flex flex-column gap-1 w-100 align-items-center">
                        <Tooltip title="Duyệt bản ghi">
                            <AntButton
                                type="primary"
                                size="small"
                                shape="round"
                                icon={<CheckOutlined />}
                                style={{ 
                                    backgroundColor: '#52c41a', 
                                    borderColor: '#52c41a', 
                                    fontSize: '11px',
                                    minWidth: '95px'
                                }}
                                onClick={() => handleApprove(item.id)}
                            >
                                Duyệt
                            </AntButton>
                        </Tooltip>
                        <Tooltip title="Từ chối duyệt">
                            <AntButton
                                type="primary"
                                danger
                                size="small"
                                shape="round"
                                icon={<CloseOutlined />}
                                style={{ 
                                    fontSize: '11px',
                                    minWidth: '95px'
                                }}
                                onClick={() => openRejectModal(item.id)}
                            >
                                Từ chối
                            </AntButton>
                        </Tooltip>
                    </div>
                )}

                {/* Admin Thu hồi khi đã duyệt hoặc từ chối */}
                {isAdmin && (item.trangThaiPheDuyet === trangThaiPheDuyetValue.daPheDuyet || item.trangThaiPheDuyet === trangThaiPheDuyetValue.tuChoi) && (
                    <div className="d-flex gap-1 justify-content-center">
                        <Tooltip title="Thu hồi thao tác (Chuyển về Chờ duyệt)">
                            <AntButton
                                type="default"
                                size="small"
                                shape="round"
                                icon={<UndoOutlined />}
                                style={{ 
                                    fontSize: '11px',
                                    minWidth: '95px'
                                }}
                                onClick={() => handleRevoke(item.id)}
                            >
                                Thu hồi
                            </AntButton>
                        </Tooltip>
                    </div>
                )}
            </div>
        );
    };

    const renderFileMinhChung = (jsonString) => {
        if (!jsonString) return <span className="text-muted">Không có</span>;
        try {
            let files = [];
            const trimmed = typeof jsonString === 'string' ? jsonString.trim() : '';
            if (trimmed.startsWith('[') && trimmed.endsWith(']')) {
                files = JSON.parse(jsonString);
            } else {
                files = [jsonString];
            }
            if (!Array.isArray(files) || files.length === 0) return <span className="text-muted">Không có</span>;
            return (
                <div className="d-flex flex-column gap-1">
                    {files.map((url, idx) => {
                        if (!url) return null;
                        let fullUrl = url;
                        if (!url.startsWith("http://") && !url.startsWith("https://")) {
                            fullUrl = BaseGatewayImage + (url.startsWith("/") ? "" : "/") + url;
                        }
                        return (
                            <a key={idx} href={fullUrl} target="_blank" rel="noopener noreferrer" style={{ fontSize: '12px' }}>
                                <FileTextOutlined className="mr-1" /> Minh chứng {idx + 1}
                            </a>
                        );
                    })}
                </div>
            );
        } catch (e) {
            let fullUrl = jsonString;
            if (typeof jsonString === 'string' && !jsonString.startsWith("http://") && !jsonString.startsWith("https://")) {
                fullUrl = BaseGatewayImage + (jsonString.startsWith("/") ? "" : "/") + jsonString;
            }
            return (
                <a href={fullUrl} target="_blank" rel="noopener noreferrer" style={{ fontSize: '12px' }}>
                    <FileTextOutlined className="mr-1" /> Minh chứng
                </a>
            );
        }
    };

    const handleSearch = (e) => {
        if (e.key === 'Enter') {
            const queryParams = {
                Keyword: keyword,
                LoaiSach: searchLoaiSach,
                SoTacGia: searchSoTacGia,
                TrangThaiPheDuyet: searchTrangThai,
                NhaXuatBan: searchNhaXuatBan,
                NamXuatBan: searchNamXuatBan,
                VaiTro: searchVaiTro,
                TenNhanVien: searchTenNhanVien
            };
            setFilterQuery(queryParams);

            const params = new URLSearchParams(location.search);
            if (params.get('page') && params.get('page') !== '1') {
                params.set('page', 1);
                history.push(`${location.pathname}?${params.toString()}`);
            } else {
                setPageIndex(1);
            }
        }
    };

    const handleSearchClick = () => {
        const queryParams = {
            Keyword: keyword,
            LoaiSach: searchLoaiSach,
            SoTacGia: searchSoTacGia,
            TrangThaiPheDuyet: searchTrangThai,
            NhaXuatBan: searchNhaXuatBan,
            NamXuatBan: searchNamXuatBan,
            VaiTro: searchVaiTro,
            TenNhanVien: searchTenNhanVien
        };
        setFilterQuery(queryParams);

        const params = new URLSearchParams(location.search);
        if (params.get('page') && params.get('page') !== '1') {
            params.set('page', 1);
            history.push(`${location.pathname}?${params.toString()}`);
        } else {
            setPageIndex(1);
        }
    };

    const handleResetFilter = () => {
        setKeyword('');
        setSearchLoaiSach('');
        setSearchSoTacGia('');
        setSearchTrangThai('');
        setSearchNhaXuatBan('');
        setSearchNamXuatBan('');
        setSearchVaiTro('');
        setSearchTenNhanVien('');
        setFilterQuery({});
        
        const params = new URLSearchParams(location.search);
        if (params.get('page') && params.get('page') !== '1') {
            params.set('page', 1);
            history.push(`${location.pathname}?${params.toString()}`);
        } else {
            setPageIndex(1);
        }
    };

    const totalPages = Math.ceil(totalItems / pageSize);

    return (
        <>
            <ResearchTabs activeKey="sach" />
            <Card className="shadow border-0">
             <Card.Header style={{ backgroundColor: '#28a745' }} className="text-white d-flex justify-content-between align-items-center">
                <h5 className="mb-0"><i className="fas fa-book mr-2" />Tra cứu thông tin sách chuyên khảo, giáo trình</h5>
                {nhanVienId && !isAdmin && (
                    <Button 
                        variant="outline-light" 
                        size="sm" 
                        className="d-inline-flex align-items-center"
                        style={{ borderRadius: '20px', padding: '4px 15px' }}
                        onClick={() => { setSelectedItem({}); setAddModalVisible(true); }}
                    >
                        <i className="fas fa-plus mr-1" /> Thêm mới
                    </Button>
                )}
            </Card.Header>
            <Card.Body>
                {isSearchVisible && (
                    <Card className="mb-4 border-0 shadow-sm">
                        <div style={{ height: '4px', backgroundColor: '#28a745' }}></div>
                    <Card.Body className="p-3 bg-light">
                        <Row>
                            <Col md={6}>
                                <BSForm.Group className="row mb-3 align-items-center">
                                    <BSForm.Label className="col-sm-3 text-sm-end font-weight-bold mb-0">Tên sách:</BSForm.Label>
                                    <div className="col-sm-9">
                                        <BSForm.Control 
                                            type="text" 
                                            placeholder="Nhập tên bằng độc quyền sáng chế, giải pháp hữu ích ..." 
                                            value={keyword}
                                            onChange={(e) => setKeyword(e.target.value)}
                                            onKeyDown={handleSearch}
                                        />
                                    </div>
                                </BSForm.Group>
                                
                                <BSForm.Group className="row mb-3 align-items-center">
                                    <BSForm.Label className="col-sm-3 text-sm-end font-weight-bold mb-0">Loại sách:</BSForm.Label>
                                    <div className="col-sm-9">
                                        <BSForm.Control 
                                            as="select"
                                            value={searchLoaiSach}
                                            onChange={(e) => setSearchLoaiSach(e.target.value)}
                                        >
                                            <option value="">Chọn loại sách</option>
                                            {LOAI_SACH.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                                        </BSForm.Control>
                                    </div>
                                </BSForm.Group>

                                <BSForm.Group className="row mb-3 align-items-center">
                                    <BSForm.Label className="col-sm-3 text-sm-end font-weight-bold mb-0">Số tác giả:</BSForm.Label>
                                    <div className="col-sm-9">
                                        <BSForm.Control 
                                            type="number" 
                                            placeholder="Nhập số lượng" 
                                            value={searchSoTacGia}
                                            onChange={(e) => setSearchSoTacGia(e.target.value)}
                                        />
                                    </div>
                                </BSForm.Group>

                                <BSForm.Group className="row mb-3 align-items-center">
                                    <BSForm.Label className="col-sm-3 text-sm-end font-weight-bold mb-0">Trạng thái:</BSForm.Label>
                                    <div className="col-sm-9">
                                        <BSForm.Control 
                                            as="select"
                                            value={searchTrangThai}
                                            onChange={(e) => setSearchTrangThai(e.target.value)}
                                        >
                                            <option value="">Chọn trạng thái</option>
                                            {objectTrangThaiPheDuyet.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                                        </BSForm.Control>
                                    </div>
                                </BSForm.Group>
                            </Col>

                            <Col md={6}>
                                <BSForm.Group className="row mb-3 align-items-center">
                                    <BSForm.Label className="col-sm-3 text-sm-end font-weight-bold mb-0">Tên nhà khoa học:</BSForm.Label>
                                    <div className="col-sm-9">
                                        <BSForm.Control 
                                            type="text" 
                                            placeholder="Nhập tên nhà khoa học..." 
                                            value={searchTenNhanVien}
                                            onChange={(e) => setSearchTenNhanVien(e.target.value)}
                                            onKeyDown={handleSearch}
                                        />
                                    </div>
                                </BSForm.Group>

                                <BSForm.Group className="row mb-3 align-items-center">
                                    <BSForm.Label className="col-sm-3 text-sm-end font-weight-bold mb-0">Nhà xuất bản:</BSForm.Label>
                                    <div className="col-sm-9">
                                        <BSForm.Control 
                                            type="text" 
                                            placeholder="Nhập tên nhà xuất bản..." 
                                            value={searchNhaXuatBan}
                                            onChange={(e) => setSearchNhaXuatBan(e.target.value)}
                                        />
                                    </div>
                                </BSForm.Group>

                                <BSForm.Group className="row mb-3 align-items-center">
                                    <BSForm.Label className="col-sm-3 text-sm-end font-weight-bold mb-0">Năm xuất bản:</BSForm.Label>
                                    <div className="col-sm-9">
                                        <BSForm.Control 
                                            type="number" 
                                            placeholder="Nhập năm xuất bản (ví dụ: 2023)..." 
                                            value={searchNamXuatBan}
                                            onChange={(e) => setSearchNamXuatBan(e.target.value)}
                                        />
                                    </div>
                                </BSForm.Group>

                                <BSForm.Group className="row mb-3 align-items-center">
                                    <BSForm.Label className="col-sm-3 text-sm-end font-weight-bold mb-0">Vai trò:</BSForm.Label>
                                    <div className="col-sm-9">
                                        <BSForm.Control 
                                            as="select"
                                            value={searchVaiTro}
                                            onChange={(e) => setSearchVaiTro(e.target.value)}
                                        >
                                            <option value="">Chọn vai trò</option>
                                            {VAI_TRO_SACH.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
                                        </BSForm.Control>
                                    </div>
                                </BSForm.Group>
                            </Col>
                        </Row>
                        <div className="d-flex justify-content-center gap-2 mt-3">
                            <Button variant="primary" onClick={handleSearchClick} style={{ borderRadius: '20px', padding: '6px 20px', display: 'inline-flex', alignItems: 'center' }}>
                                <i className="fas fa-search mr-1" /> Tra cứu
                            </Button>
                            <Button variant="danger" onClick={handleResetFilter} style={{ borderRadius: '20px', padding: '6px 20px' }}>
                                Làm mới bộ lọc
                            </Button>
                        </div>
                    </Card.Body>
                </Card>
                )}

                {loading ? (
                    <div className="d-flex justify-content-center align-items-center" style={{ height: '300px' }}>
                        <Spinner animation="border" variant="primary" />
                    </div>
                ) : (
                    <>
                        <Table striped bordered hover responsive>
                            <thead className="bg-light">
                                <tr>
                                    <th>TT</th>
                                    <th>Tên nhà khoa học</th>
                                    <th>Tên sách</th>
                                    <th>Loại sách (CK, GT, TK, HD, CTDT)</th>
                                    <th>Nhà xuất bản và năm xuất bản</th>
                                    <th>Số tác giả</th>
                                    <th>Số chương biên soạn</th>
                                    <th>Chủ biên</th>
                                    <th>Phần biên soạn (từ trang ... đến trang)</th>
                                    <th>Xác nhận của cơ sở GDĐH (số văn bản xác nhận sử dụng sách)</th>
                                    <th>Minh chứng</th>
                                    <th>Trạng thái / Thao tác</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((s, index) => (
                                    <tr key={s.id}>
                                        <td>{index + 1 + (pageIndex - 1) * pageSize}</td>
                                        <td><span className="font-weight-bold">{s.tenNhanVien || s.nhanVien?.hoTen || 'Chưa rõ'}</span></td>
                                        <td>
                                            <strong>{s.tenSach}</strong>
                                            {renderFirstFileLink(s.fileMinhChung)}
                                        </td>
                                        <td>{LOAI_SACH.find(o => o.value === s.loaiSach)?.label || s.loaiSach}</td>
                                        <td>{s.nhaXuatBan} ({s.namXuatBan})</td>
                                        <td>{s.soTacGia}</td>
                                        <td>{s.soChuongSach || '-'}</td>
                                        <td>{VAI_TRO_SACH.find(o => o.value === s.vaiTro)?.label || s.vaiTro}</td>
                                        <td>
                                            {(s.phanBienSoanTuTrang === 0 && s.phanBienSoanDenTrang === 0) || (!s.phanBienSoanTuTrang && !s.phanBienSoanDenTrang)
                                                ? '-'
                                                : `${s.phanBienSoanTuTrang} - ${s.phanBienSoanDenTrang}`}
                                        </td>
                                        <td>{s.xacNhanCoSo || '-'}</td>
                                        <td>{renderFileMinhChung(s.fileMinhChung)}</td>
                                        <td className="text-center">
                                            <div className="d-flex flex-column align-items-center gap-1">
                                                {renderApprovalBadge(s)}
                                                {renderActionButtons(s)}
                                            </div>
                                        </td>
                                    </tr>
                                ))}
                                {data.length === 0 && (
                                    <tr>
                                        <td colSpan={11} className="text-center text-muted">Không tìm thấy sách nào</td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>

                        {totalItems > pageSize && (
                            <div className="d-flex justify-content-end mt-3">
                                <Pagination
                                    itemClass="page-item"
                                    linkClass="page-link"
                                    innerClass="pagination pagination-sm no-margin"
                                    activePage={pageIndex}
                                    itemsCountPerPage={pageSize}
                                    totalItemsCount={totalItems}
                                    pageRangeDisplayed={5}
                                    onChange={handlePageChange}
                                />
                            </div>
                        )}
                    </>
                )}
            </Card.Body>

            <Modal
                title="Từ chối duyệt Sách/Giáo trình"
                open={rejectVisible}
                onOk={handleRejectSubmit}
                onCancel={() => setRejectVisible(false)}
                okText="Xác nhận từ chối"
                okButtonProps={{ danger: true }}
                cancelText="Hủy bỏ"
            >
                <div className="mb-2">Vui lòng nhập lý do từ chối:</div>
                <TextArea
                    rows={4}
                    value={rejectReason}
                    onChange={(e) => setRejectReason(e.target.value)}
                    placeholder="Lý do bản ghi này không hợp lệ..."
                />
            </Modal>

            <SachModal
                visible={addModalVisible}
                onCancel={() => setAddModalVisible(false)}
                onSubmit={handleSaveItem}
                initialValues={selectedItem}
            />
        </Card>
    </>
);
};

export default SachList;
